import * as polyfills from "./scripts/polyfills/ie";

import Collapse from 'bootstrap.native/dist/components/collapse-native.esm';
onFind('[data-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import {translate} from '@c0necto/elements-translations';

import './scripts/common';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/
import {onFind} from "@c0necto/elements-init-modules-in-scope";
import {on} from "@c0necto/elements-dom-utils";

import * as popover from './scripts/popover';
popover.init();

import * as ajaxForm from '@c0necto/elements-ajax-form';
ajaxForm.init({
    allowScriptTags: true
});

import * as ajaxFormMap from './scripts/ajax-form-map';
ajaxFormMap.init();

import * as rangeSlider from '@c0necto/elements-range-slider';
rangeSlider.init();

import * as submitForm from './scripts/submit-form';
submitForm.init();

import * as filterDropdown from './scripts/filter-dropdown';
filterDropdown.init();

import * as overlayToggle from './scripts/overlay-toggle';
overlayToggle.init();

import * as accommodationOverview from './scripts/accommodation-overview';
accommodationOverview.init();

import * as accoPoolEnquiryToggle from './scripts/acco-pool-enquiry';
accoPoolEnquiryToggle.init();

import * as datepickerRange from "./scripts/datepicker-range";
onFind('.js-datepicker-range', function (baseElement) {
    datepickerRange.createDatepicker(
        baseElement,
        {
            /*options*/
            mode: "range",
            allowInput: true,
            showMonths: 2,
            disableMobile: "false",
            minDate: "today",
        },{
            base: '.datepicker-range-container',
            input: '.js-datepicker-range__input',
            altField: '.js-datepicker-range__alt-field',
            altFieldRangeTo: '.js-datepicker-range__range-to-alt-field'
        }
    );
});

import * as affixMap from '@c0necto/elements-affix';
affixMap.init({
        mediaQuery: '(min-width: 768px)'
    },
    {
        base: '.js-affix-map',
        placeholder: '.js-affix-map__placeholder',
        container: '.js-affix-map__container'

    });

import * as accoPoolEnquiry from './scripts/pool-enquiry';
accoPoolEnquiry.init({
    renderFunctions: {
        "inputs": {
            'item':(data) => {
                let markupElementInput = document.createElement('div');
                markupElementInput.innerHTML = `<div><input class="" name="pool-enquiries[]" value="${data.id}" hidden> <input class="js-pool-enquiry__kognitiv-id" name="pool-enquiries-kognitiv[]" value="${data.kognitivId}" hidden></div>`;

                return markupElementInput.childNodes[0];
            }
        },
        "result": {
            'item': (data, onRemove, baseElement) => {
                let markupElementItem = document.createElement('div');
                let markupElementRemoveButton = document.createElement('div');

                markupElementItem.innerHTML = `<div class="catalog-teaser catalog-teaser--enquiry vertical-gutter__item"><div class="row row-gutter--0 align-items-center"><div class="col-3"><img src="${data.imgSrc}" class="img-fluid" alt="Katalog"></div><div class="col-9"><div class="catalog-teaser__body"><div class="h4 catalog-teaser__title text-primary">${data.title}</div></div></div></div></div>`;
                markupElementRemoveButton.innerHTML = '<button class="btn btn-remove"><span class="icon icon-plus" aria-label="remove"></button>';

                const removeClickHandler = evt => {
                    onRemove(data.id, {}, baseElement);
                };

                on('click', removeClickHandler, markupElementRemoveButton.childNodes[0]);
                markupElementItem.childNodes[0].appendChild(markupElementRemoveButton.childNodes[0]);
                return markupElementItem.childNodes[0];
            },
            'fallback': `<div class="enquiry-fallback">${translate('enquiry.nothingAdded')}</div>`
        }
    },
    maxItemsNotification: {
        type: 'basic',
        title: translate('enquiry.error.title'),
        content: translate('enquiry.error.text'),
        closable: true,
        styleModifier: 'pool-enquiry-max-items-notification',
        icon: 'warning',
    }
},
    {
        parent: '.js-pool-enquiry__parent',
        base: '.js-pool-enquiry',
        button: '.js-pool-enquiry__btn',
        submitForm: '.js-pool-enquiry__submit-form',
        selectionView: '.js-pool-enquiry__selection-view',
        counter: '.js-pool-enquiry__counter'
    });

import * as keepDropdownOpen from './scripts/keep-dropdown-open';
keepDropdownOpen.init();

import * as quickfinderRoom from './scripts/quickfinder-room';
quickfinderRoom.init();

import * as typeahead from './scripts/typeahead';
typeahead.init();
